import React, { useState } from "react";
import { NavigationContext } from "../context/NavigationContext";
import {
  useLocation,
  Routes,
  Route,
  BrowserRouter,
  useNavigate,
} from "react-router-dom";
import InnerApp from "../layouts/InnerApp";
import appSchemeMap from "../util/appSchemeMap";
import { AnimatePresence } from "framer-motion";
import { MixpanelPageViewTracker } from "../components/MixpanelPageViewTracker";
import DynamicContentPage from "../pages/DynamicContentPage";
import Custom404Page from "../pages/Custom404Page";
import AuthTestPage from "../pages/AuthTestPage";

function CastleRoutes() {
  const location = useLocation();
  const navigate = useNavigate();
  const [lastNavigatedAt, setLastNavigatedAt] = useState(Date.now());
  const [direction, setDirection] = useState("next");
  const [nextButtonDisabled, setNextButtonDisabled] = useState(false);
  const [onSubmit, setOnSubmit] = useState(
    () => () => console.error("onSubmit not replaced")
  );
  const [nextHistory, setNextHistory] = useState(
    JSON.parse(localStorage.getItem("nextHistory")) || []
  );
  const currentUrl = window.location.href.replace(
    process.env.REACT_APP_URL,
    ""
  );
  const goBack = () => {
    setDirection("back");
    setLastNavigatedAt(Date.now());
    navigate(-1);
  };

  const goNext = (url, shouldSetNextHistory = false) => {
    setDirection("next");
    setLastNavigatedAt(Date.now());
    navigate(url);
    if (shouldSetNextHistory) {
      const newNextHistory = [...nextHistory];
      newNextHistory.push(currentUrl);
      setNextHistory(newNextHistory);
      localStorage.setItem("nextHistory", JSON.stringify(newNextHistory));
    }
  };

  const nextButtonVisible = nextHistory.includes(currentUrl);

  const navigationContext = {
    goBack,
    goNext,
    direction,
    onSubmit,
    setOnSubmit,
    nextButtonDisabled,
    setNextButtonDisabled,
    nextButtonVisible,
    lastNavigatedAt,
  };

  return (
    <NavigationContext.Provider value={navigationContext}>
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<InnerApp />}>
            {Object.values(appSchemeMap).map(
              ({ url, component: RouteComponent, props = {} }) => (
                <Route
                  key={url}
                  path={url}
                  element={<RouteComponent {...props} />}
                />
              )
            )}
            <Route path="*" element={<DynamicContentPage />} />
            <Route element={<Custom404Page />} />
          </Route>
        </Routes>
      </AnimatePresence>
    </NavigationContext.Provider>
  );
}

function CastleRouter() {
  return (
    <BrowserRouter>
      <MixpanelPageViewTracker />
      <CastleRoutes />
    </BrowserRouter>
  );
}

export default CastleRouter;
